module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "ticketPriceContainer flex-grow overflow-auto"
  }, _vm._l((_vm.orderedBookingGenderPrices), function(personPrice, index) {
    return _c('reservation-ticket-price', {
      key: index,
      attrs: {
        "personPrice": personPrice,
        "reservation": _vm.reservation,
        "isEditing": _vm.editingPax
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "mb-1 d-flex flex-row align-items-center mt-2"
  }, [_c('div', {
    staticClass: "fs-largest darker font-weight-600 flex-grow-1"
  }, [_vm._v("\n            Total Pax: " + _vm._s(_vm.totalPax) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.editBtnTooltip),
      expression: "editBtnTooltip"
    }],
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.disableEditBtn || _vm.isReservationReadOnly && _vm.reservation.status != -5
    },
    on: {
      "click": _vm.toggleEditPax
    }
  }, [_vm._v(_vm._s(_vm.editingPax ? 'Apply' : 'Edit'))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-185a3190", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185a3190"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/reservationTicketPrices.vue
// module id = 1907
// module chunks = 0